const initialState = () => ({
  isOpened: false,
  onSuccessCallback: null,
  modalData: {
    title: '',
    description: '',
    confirmationTerm: '',
    prescriptionName: ''
  }
});

const ACTION_KEY = 'PAD_MODEL_CREATOR_PRESCRIPTION_CONFIRMATION_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { modalData, onSuccessCallback } = action.payload;

      return {
        ...state,
        isOpened: true,
        modalData: {
          title: modalData.title,
          description: modalData.description,
          confirmationTerm: modalData.confirmationTerm,
          prescriptionName: modalData.prescriptionName
        },
        onSuccessCallback
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
